import styled from "@emotion/styled"
import { Button } from "@mui/material"
import { Attribute } from "api"
import { AppType, useAppType } from "contexts/AppTypeProvider"
import { LocationContext } from "contexts/LocationProvider"
import { useContext, useEffect, useState } from "react"
import { trackStationsResetFilter } from "reusable/gtm"
import { ButtonWithArrow, NewText, useIsDesktop } from "ui"
import { FilterContainer } from "./FilterContainer"

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 16px;
`
const FiltersWrapper = styled.div`
  padding-right: 20px;
    ${(props) => props.theme.breakpoints.up("md")} {
  padding-left: 14px;
  }
`
export const StyledLegend = styled.legend`
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  white-space: nowrap;
`
const StyledCat = styled.fieldset`
  display: flex;
  flex-direction: column;
  border: none;
  padding: 0;
  margin: 0;

  gap: 16px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-left: 16px;
    padding-right: 16px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    padding-left: 24px;
    padding-right: 24px;
  }
`
const StyledActions = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: space-between;
  background-color: white;
  border-top: 1px solid rgba(179, 201, 219, 0.7);
  padding-top: 10px;
  padding-bottom: 10px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 16px;
  }
`
const STyledResetButton = styled(Button)`
  color: rgba(0, 80, 201, 1);
  font-size: 12px;
  ${(props) => props.theme.breakpoints.up("md")} {
    font-size: 12px;
  }
  ${(props) => props.theme.breakpoints.up("lg")} {
    font-size: 16px;
  }
`
const StyledFiltersPazCharge = styled.div`
display: flex;
flex-direction: column;
gap: 15px;
`
type Props = {
  metadata: Attribute[]
  handleClose?: () => void
}

function StyledFilters({ metadata, handleClose }: Props) {
  const { appType } = useAppType();
  const isPazCharge = appType === AppType.Charge;
  const { filters, resetFilters, initialValueFilters, updateFilters } = useContext(LocationContext)
  const [interimFilters, setInterimFilters] = useState<Attribute[]>(filters || [])
  const [filtersUpdatedOnce, setFiltersUpdatedOnce] = useState(false)
  const handleFilter = () => {
    updateFilters([...interimFilters || []])
    if (handleClose) {
      handleClose()
    }
  }
  const handleReset = () => {
    setInterimFilters(initialValueFilters || [])
    resetFilters()
    trackStationsResetFilter()
  }
  useEffect(() => {
    if (filters && filters.length && !filtersUpdatedOnce) {
      setInterimFilters(filters)
      setFiltersUpdatedOnce(true)
    }
  }, [filtersUpdatedOnce, filters])

  const categories = isPazCharge ? ["שירותי רכב"] : ["שירותי רכב", "yellow", "סופרים"]
  const onlyYellowFilters = metadata.filter((el) => el.category.toLowerCase() === "yellow")
  const isDesktop = useIsDesktop()
  const { selectedLocation } = useContext(LocationContext)

  return (
    <>
      <StyledContainer>
        {!isPazCharge && categories.map((cat) => {
          const filtered = metadata.filter((el) => el.category.toLowerCase() === cat)
          return (
            <StyledCat key={cat}>
              <StyledLegend>סינון לפי {cat}</StyledLegend>
              <NewText
                component="h3"
                largeDesktopFontSize={20}
                largeDesktopLineHeight={"28px"}
                mobileFontSize={20}
                mobileLineHeight={"28px"}
                desktopFontSize={14}
                desktopLineHeight={"19.6px"}
                desktopFontWeight={"500"}
              >
                {cat}
              </NewText>
              <FilterContainer filters={filtered} interimFilters={interimFilters} setInterimFilters={setInterimFilters} />
            </StyledCat>
          )
        })}
        {
          isPazCharge &&
          <StyledFiltersPazCharge>
            <FiltersWrapper>
              <FilterContainer filters={onlyYellowFilters} interimFilters={interimFilters} setInterimFilters={setInterimFilters} />
            </FiltersWrapper>
          </StyledFiltersPazCharge>
        }
        <StyledActions>
          <STyledResetButton
            variant="text"
            onClick={handleReset}
            tabIndex={selectedLocation ? -1 : 0}
          >
            איפוס
          </STyledResetButton>
          {!isDesktop &&
            <ButtonWithArrow
              role="presentation"
              tabIndex={-1}
              onClick={handleFilter}
              desktopHeight={41}
              desktopWidth={115}
              largeDesktopWidth={170}
              title="הצגת תוצאות"
              svgRelative
              desktopFontSize={12}
              largeDesktopFontSize={16}
              mobileWidth={150}
            />}
        </StyledActions>
      </StyledContainer>

    </>
  )
}

export default StyledFilters
